export enum Tabs {
  ACCOUNTS,
  ACTIVITIES,
  ADMIN_HOME,
  ASSESSMENTS,
  CONFIGURATION,
  DEFAULT,
  FAMILIES,
  GOALS,
  LOGIN,
  MESSAGES_AND_NOTIFICATIONS,
  ORGANIZATIONS,
  PROFILE,
  REPORTS,
  TEACHER_DASHBOARDS,
  TEACHER_HOME,
  TEACHER_USERS,
  NOTIFICATIONS_MANAGER,
}
